/**
 * Shipped stand-in photography for content cards.
 *
 * These live in `frontend/public/img` and are served by the SPA itself, so they
 * are the one image source that cannot 404 the way an API-hosted MediaFile can.
 * They are used in two situations:
 *
 *   1. the record genuinely has no image reference (handled by the caller that
 *      builds the card, e.g. `Landing.jsx`'s `cardImage`), and
 *   2. the record *has* a reference but the file is gone — a live DB/storage
 *      desync — in which case the presentational component swaps to the same
 *      photo on the `<img>`'s `error` event.
 *
 * This module exists so both of those callers share one list. A presentational
 * component must never reach into a page module for it.
 *
 * The list is intentionally small and generic (no deck photos, no faces tied to
 * a specific club) so an unrelated card never implies it is about those people.
 */
export const STATIC_GALLERY = [
  '/img/community.jpg',
  '/img/unity-hands.jpg',
  '/img/give-heart.jpg',
  '/img/story-a.jpg',
  '/img/story-b.jpg',
  '/img/hero-leader.jpg',
];

/**
 * Pick a stand-in photo for card position `index`.
 *
 * Deterministic on purpose: the same slot always resolves to the same photo, so
 * a re-render (a hover, a route transition, a parent state change) never
 * reshuffles the imagery under the reader. Non-integer or negative seeds are
 * normalized rather than producing `undefined`.
 */
export function fallbackImage(index) {
  const n = Number.isFinite(index) ? Math.trunc(index) : 0;
  const i = ((n % STATIC_GALLERY.length) + STATIC_GALLERY.length) % STATIC_GALLERY.length;
  return STATIC_GALLERY[i];
}
